import z from 'zod';
import { paramTypeNameSchema } from './paramTypeSchema.js';
import { timestampSchema } from './commonSchemas.js';
import { organizationDefRowSchema } from './organizationDefSchema.js';
/**
 * Schema per ParamTypeValue
 * Definisce i tipi di valore concreti che può assumere un parametro
 * Rappresenta i tipi di valore che possono essere associati ai parametri
 */
export const paramTypeValueSchema = z.enum([
    'number',
    'boolean',
    'date',
    'range_number',
    'range_date',
    'number_array',
    'date_array'
]);
/**
 * Schema per ParamDef
 * Definisce un singolo parametro associabile a uno o più bonus
 * Struttura del parametro senza il suo valore specifico
 */
export const paramDefSchema = z.object({
    /** Nome del parametro come appare in Bonus */
    name: z.string().min(1, "Il nome del parametro è obbligatorio"),
    /** Descrizione del parametro come appare in Bonus */
    description: z.string().optional().nullable(),
    /** Tipo di parametro (es. eq, min, max, etc.) */
    type_name: paramTypeNameSchema,
    /** Il tipo di valore del parametro (es. number, date, etc.) */
    type_value: paramTypeValueSchema,
    attribute_id: z.number().int().positive().optional().nullable()
});
/**
 * Schema per ParamDefRow
 * Rappresenta il tipo di riga della tabella dei parametri
 * @db_table parameters
 */
export const paramDefRowSchema = z.object({
    /** ID del parametro */
    id: z.number().int().positive().describe('type:number,editable:false,label:ID'),
    // campi di param_data riportati qui in attesa di eliminare il jsonb
    /** Nome del parametro come appare in Bonus */
    name: z.string().min(1, "Il nome del parametro è obbligatorio").describe('label:Titolo'),
    /** Descrizione del parametro come appare in Bonus */
    description: z.string().optional().nullable().describe('type:textarea,label:Descrizione'),
    /** Tipo di parametro (es. eq, min, max, etc.) */
    type_name: paramTypeNameSchema.describe('type:string,label:Tipo'),
    /** Il tipo di valore del parametro (es. number, date, etc.) */
    type_value: paramTypeValueSchema.describe('type:string,label:Valore'),
    attribute_id: z.number().int().positive().optional().nullable(),
    // fine campi di param_data
    /** Dati del parametro */
    parameter_data: paramDefSchema,
    /** ID dell'organizzazione */
    organization_id: z.number().int().nonnegative().optional().describe('type:organization,label:Organizzazione'),
    /** Metadati aggiuntivi per il parametro che possono servire per la UI */
    metadata: z.record(z.string(), z.any()).optional().nullable(),
    /**
     * È un parametro core?
     * Se true, il parametro è considerato core e non può essere eliminato
     */
    is_core: z.boolean().optional().describe('label:Non eliminabile,defaultValue:false').default(true),
    /** Data di creazione */
    created_at: timestampSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    /** Data di ultimo aggiornamento */
    updated_at: timestampSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
export const paramDefRowSchemaNoId = paramDefRowSchema.omit({ id: true, created_at: true, updated_at: true });
/**
 * Schema per ParamDefRowView
 * @db_view parameters_list_view
 */
export const paramDefRowSchemaView = paramDefRowSchema.extend({
    name: z.string(),
    /** Descrizione del parametro come appare in Bonus */
    description: z.string().optional().nullable(),
    organization_info: organizationDefRowSchema.extend({
        territorial_info: z.any().optional().nullable(), // JSON delle informazioni territoriali
    }).optional().nullable(),
    organization_name: z.string().optional().nullable(),
    /** Tipo di parametro (es. eq, min, max, etc.) */
    type_name: paramTypeNameSchema,
    /** Il tipo di valore del parametro (es. number, date, etc.) */
    type_value: paramTypeValueSchema,
    attribute_id: z.number().int().positive().optional().nullable(),
    attribute_name: z.string().optional().nullable(),
});
//# sourceMappingURL=paramDefSchema.js.map